import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { NOUS_CONTACTER } from "@shared/constants/route.constants";
import { ClaimsRedirectValues } from "@shared/enums/claims-redirect-values";
import { ClaimsType } from "@shared/enums/claims.type";
import { ClaimsTypeService } from "@shared/services/claims-type.service";
import { Guid } from "guid-typescript";
import { ButtonModule } from "primeng/button";
import { ClaimsButtonComponent } from "./claims-buttons/claims-button.component";
import { DocumentsVm } from "@shared/models/policy-details";
import { DocumentActionType } from "@shared/enums/document-action.type";
import { DocumentService } from "@shared/services/document.service";

@Component({
  selector: "app-service-offerings-sa",
  standalone: true,
  imports: [CommonModule, TranslateModule, ButtonModule, ClaimsButtonComponent],
  templateUrl: "./service-offerings-sa.component.html",
})
export class ServiceOfferingsSaComponent implements OnInit {
  @Input({ required: true }) policyId!: Guid;
  @Input({ required: true }) policyReference!: string;
  @Input({ required: true }) isConfortProduct!: boolean;
  @Input({ required: true }) fSDocument!: DocumentsVm;
  @Input() hasLegalJr = false;
  @Input() isGdaAllowed = false;
  @Input() isPolicyActive = false;
  ClaimsRedirectValues = ClaimsRedirectValues;
  ClaimsType = ClaimsType;
  isLoading = false;
  claims: any[] = [];

  constructor(
    private readonly claimTypeService: ClaimsTypeService,
    private readonly documentService: DocumentService,
    private readonly router: Router
  ) {}

  ngOnInit() {
    this.claims = this.claimTypeService.getClaims();
    if (this.isPolicyActive) {
      this.claims = this.claims.filter(claim => claim.claimsType === ClaimsType.RMA);
    }
  }

  redirectToContactUs() {
    const policyId = this.policyId;
    this.router.navigate([NOUS_CONTACTER], { queryParams: { policyId } });
  }

  downloadFsDocument() {
    const documentId = this.fSDocument.documentId;
    if (!documentId) return; // Early return if no documentId exists
    this.downloadDocumentApi(documentId, DocumentActionType.DOWNLOAD);
  }

  downloadDocumentApi(documentId: Guid, actionType: DocumentActionType) {
    this.documentService.getAgreementDocument(documentId).subscribe(data => {
      actionType == DocumentActionType.DOWNLOAD
        ? this.documentService.onDownload(documentId)
        : this.documentService.onView(documentId);
    });
  }
}
